import { RouteObject } from "react-router"
import AtendimentoList from "./view/atendimento.list"
import AtendimentoCadastro  from "./view/atendimento.cad"
import AtendimentoShell,{AtendimentoStart} from "./view/atendimento.start"
import Atendimento from "./view/atendimento"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../config/data.types"
import { MedicalInformation, MenuOpen } from "@mui/icons-material"
import store from "../../store"
import { atendimentoController } from "./atendimento.controller"
import { medicoController } from "../medico/medico.controller"
import { salaController } from "../sala/sala.controller"


const loadAtendimentoCad = () => {
    store.dispatch(atendimentoController.reducer.actions.readAtendimentoToday())

        if(medicoController.state.rows.length === 0)
            store.dispatch(medicoController.reducer.actions.read())
        if(salaController.state.rows.length === 0)
            store.dispatch(salaController.reducer.actions.read())
}

export enum PathRotaAtendimento {
    shell = "/inicio",
    entrada = "/inicio/entrada",
    atendendo = "/inicio/atendendo",
    listAtendimento = "/inicio/atendimentos",
    abrirAtendimento = "/inicio/abrirAtendimento",
}

const routerAtendimento: RouteObject = {
    path: PathRotaAtendimento.shell,
    element: <AtendimentoShell/>,
    children:[
        {
            path:PathRotaAtendimento.entrada,
            element: <AtendimentoStart   />

        },        
        {
            path:PathRotaAtendimento.abrirAtendimento,
            element: <AtendimentoCadastro   />,
            loader:loadAtendimentoCad
        },
        {
            path:PathRotaAtendimento.listAtendimento,
            element:<AtendimentoList />
        },
        {
            path:PathRotaAtendimento.atendendo,
            element:<Atendimento />,
        }        

    ]
}


export const navigationToAtendimentoView = ()=> rotas.navigate(PathRotaAtendimento.shell)

export function startRouterAtendimento(){
    const menu:MainMenu = {
        text:"Atendimento",
        icon:<MedicalInformation />,
        eventOnClick:navigationToAtendimentoView
    }
    menuRotas.push(menu);
    return routerAtendimento
}